import { TypedUseSelectorHook, useSelector } from "react-redux";

import { RootStateTypes } from "../../store/reducers";

export const useTypedSelectorHook: TypedUseSelectorHook<RootStateTypes> =
  useSelector;
